import React from "react";
import { Container } from "./button.styles";
import { ButtonProps } from "./button.types";

const ProcessingIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><g><g transform="rotate(0 50 50)">
    <rect height="25" width="5" ry="0" rx="0" y="-0.5" x="47.5">
      <animate repeatCount="indefinite" begin="-0.9166666666666666s" dur="1s" keyTimes="0;1" values="1;0" attributeName="opacity"></animate>
    </rect>
  </g><g transform="rotate(30 50 50)">
      <rect height="25" width="5" ry="0" rx="0" y="-0.5" x="47.5">
        <animate repeatCount="indefinite" begin="-0.8333333333333334s" dur="1s" keyTimes="0;1" values="1;0" attributeName="opacity"></animate>
      </rect>
    </g><g transform="rotate(60 50 50)">
      <rect height="25" width="5" ry="0" rx="0" y="-0.5" x="47.5">
        <animate repeatCount="indefinite" begin="-0.75s" dur="1s" keyTimes="0;1" values="1;0" attributeName="opacity"></animate>
      </rect>
    </g><g transform="rotate(90 50 50)">
      <rect height="25" width="5" ry="0" rx="0" y="-0.5" x="47.5">
        <animate repeatCount="indefinite" begin="-0.6666666666666666s" dur="1s" keyTimes="0;1" values="1;0" attributeName="opacity"></animate>
      </rect>
    </g><g transform="rotate(120 50 50)">
      <rect height="25" width="5" ry="0" rx="0" y="-0.5" x="47.5">
        <animate repeatCount="indefinite" begin="-0.5833333333333334s" dur="1s" keyTimes="0;1" values="1;0" attributeName="opacity"></animate>
      </rect>
    </g><g transform="rotate(150 50 50)">
      <rect height="25" width="5" ry="0" rx="0" y="-0.5" x="47.5">
        <animate repeatCount="indefinite" begin="-0.5s" dur="1s" keyTimes="0;1" values="1;0" attributeName="opacity"></animate>
      </rect>
    </g><g transform="rotate(180 50 50)">
      <rect height="25" width="5" ry="0" rx="0" y="-0.5" x="47.5">
        <animate repeatCount="indefinite" begin="-0.4166666666666667s" dur="1s" keyTimes="0;1" values="1;0" attributeName="opacity"></animate>
      </rect>
    </g><g transform="rotate(210 50 50)">
      <rect height="25" width="5" ry="0" rx="0" y="-0.5" x="47.5">
        <animate repeatCount="indefinite" begin="-0.3333333333333333s" dur="1s" keyTimes="0;1" values="1;0" attributeName="opacity"></animate>
      </rect>
    </g><g transform="rotate(240 50 50)">
      <rect height="25" width="5" ry="0" rx="0" y="-0.5" x="47.5">
        <animate repeatCount="indefinite" begin="-0.25s" dur="1s" keyTimes="0;1" values="1;0" attributeName="opacity"></animate>
      </rect>
    </g><g transform="rotate(270 50 50)">
      <rect height="25" width="5" ry="0" rx="0" y="-0.5" x="47.5">
        <animate repeatCount="indefinite" begin="-0.16666666666666666s" dur="1s" keyTimes="0;1" values="1;0" attributeName="opacity"></animate>
      </rect>
    </g><g transform="rotate(300 50 50)">
      <rect height="25" width="5" ry="0" rx="0" y="-0.5" x="47.5">
        <animate repeatCount="indefinite" begin="-0.08333333333333333s" dur="1s" keyTimes="0;1" values="1;0" attributeName="opacity"></animate>
      </rect>
    </g><g transform="rotate(330 50 50)">
      <rect height="25" width="5" ry="0" rx="0" y="-0.5" x="47.5">
        <animate repeatCount="indefinite" begin="0s" dur="1s" keyTimes="0;1" values="1;0" attributeName="opacity"></animate>
      </rect>
    </g><g></g></g></svg>
);

const CompleteIcon = () => (
  <svg viewBox="0 0 34 24" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M33.5523 3.38177C33.9329 3.78196 33.917 4.41493 33.5168 4.79553L14.1925 23.1738C13.0343 24.2754 11.2159 24.2754 10.0576 23.1738L0.483409 14.0683C0.0832123 13.6877 0.0673316 13.0547 0.447938 12.6545L3.20453 9.75601C3.58514 9.35582 4.21811 9.33994 4.6183 9.72054L11.4359 16.2045C11.822 16.5716 12.4282 16.5716 12.8142 16.2045L29.3819 0.447816C29.7821 0.0672095 30.4151 0.0830904 30.7957 0.483287L33.5523 3.38177Z" fill="#262642" />
  </svg>
);

const Icon = ({ processing, complete }: { processing?: boolean, complete?: boolean }) => {
  if (complete) {
    return <CompleteIcon />
  }

  if (processing) {
    return <ProcessingIcon />
  }

  return null
}

export const Button = ({ type, label, processing, complete, color, size, expand, disabled, pre, onClick }: ButtonProps) => {

  return (
    <Container type={type} disabled={disabled} $size={size} $expand={expand} $color={color} $processing={processing} $complete={complete} onClick={onClick}>
      <Icon processing={processing} complete={complete} />
      {pre && <span>{pre}</span>}{label}
    </Container>
  );
}